import { api } from './config';
import axios from '@/common/js/axiox';

export async function getSchoolList(userId) {
  return await axios.get(`${api.schoolUrl}/${userId}`).then((res) => {
    return res.data;
  });
}

export async function schoolUtil(school, _type) {
  const {
    userId,
    uuid,
    schoolName,
    type,
    admins
  } = school;
  switch (_type) {
    case 1:
      return await axios.post(api.schoolUrl, {
        userId,
        schoolName,
        type,
        admins
      }).then((res) => {
        return res.data;
      });
    case 2:
      return await axios.put(api.schoolUrl, {
        userId,
        uuid,
        schoolName,
        type,
        admins
      }).then((res) => {
        return res.data;
      });
  }
}